module.exports = __webpack_public_path__ + "img/fixtures-dropdown-icon.143a4646.svg";